<div *ngIf="showLoader" class="loader loader-default is-active" data-blink [attr.data-text] =" loaderText "></div>